module.exports = __webpack_public_path__ + "media/hyper/images/logo_sm-e4ac7f99565bca506f3e86364f5ef2b1.png";